import { Dialog, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState, memo } from "react";

import { useTranslation } from "react-i18next";
import { Props, State } from "./interfaces";
import PendingHEApprovals from "./PendingHEApprovals";
import { DialogContent } from "./styles";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { isAuthorizedEeGroup } from "../../../../custom-hooks/useAuthorization/useAuthorization";
import { EmployeeGroupRef } from "../../../../models/employee-groups";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";
import DialogActions from "../../../DialogActions/DialogActions";
import DialogTitle from "../../../DialogTitle/DialogTitle";
import LoadingOverlay from "../../../LoadingOverlay/LoadingOverlay";

const PendingEHApprovalModal = ({ children, notifyParent, employee }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.my_calendar.add_extra_hours";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const hasAccess = isAuthorizedEeGroup(
    [AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves],
    currentUserAuthorizations,
    employee?.groups?.map((group: EmployeeGroupRef) => group?.id) ?? []
  );

  const allowedToViewOnly = isAuthorizedEeGroup(
    [AUTHORIZATIONS.EmployeesAccess.ViewNonSalaryAndCompensationData],
    currentUserAuthorizations,
    employee?.groups?.map((group: EmployeeGroupRef) => group?.id) ?? []
  );

  const [state, setState] = useState<State>({
    openDialog: false,
    loading: false,
    error: "",
    items: [],
    isMutated: false,
    mutatingStatus: "",
    confirmStatus: false,
    mutatingStatusValue: false,
    isConfirmationDialogOpen: false,
    confirmationDialogTitle: "",
    confirmationDialogMessage: "",
    confirmationDialogActionsAndHandlers: [],
    extraHours: null,
  });

  const setOpenDialog = (value: boolean) => setState((state) => ({ ...state, openDialog: value }));

  const handleCloseDialog = () => {
    setState((state) => ({
      ...state,
      error: "",
      openDialog: false,
    }));
    notifyParent();
  };

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setOpenDialog(true)}
      >
        {children}
      </Grid>
      {(hasAccess || allowedToViewOnly) && (
        <Dialog
          open={state.openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth={"md"}
        >
          <DialogTitle
            title={`${employee?.name}'s extra hours`}
            handleClose={handleCloseDialog}
          />
          <LoadingOverlay loading={state.loading}>
            <DialogContent>
              <PendingHEApprovals
                employee={employee}
                height={400}
              />
            </DialogContent>
            <DialogActions
              handleCancel={handleCloseDialog}
              loading={state.loading}
              error={state.error}
            />
          </LoadingOverlay>
        </Dialog>
      )}
    </>
  );
};

export default memo(PendingEHApprovalModal);
